import { render, staticRenderFns } from "./AddNewQuery.vue?vue&type=template&id=36b83796&"
import script from "./AddNewQuery.vue?vue&type=script&lang=js&"
export * from "./AddNewQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports